import { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import Message from "./Message/Message";


const ChatViewField = () =>
{

  const divRef = useRef(null);

  const messages = useSelector((state) => state.messages);

  useEffect(() =>
  {
    divRef.current.scrollIntoView({});
  })

  return (
    !messages.length ? (
      <div ref={divRef} style={{padding:"5px 0 0 5px"}}>
        <p>
          No messages（*＾-＾*）
        </p>
      </div>
    )
      : (
        <div style={{padding:"5px 0 0 5px"}}>
          {messages.slice(0).reverse().map((message, index) => (
            <Message key={index} data={message} />
          ))}
          <div ref={divRef}/>
        </div>
      )
  )
}

export default ChatViewField;